function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useMutation, useQuery, useLazyQuery } from "@apollo/client";
import classNames from "classnames";
import moment from "moment-timezone";
import React, { useEffect } from "react";
import Button from "react-bootstrap/Button";
import FormControl from "react-bootstrap/FormControl";
import Tab from "react-bootstrap/Tab";
import Table from "react-bootstrap/Table";
import Tabs from "react-bootstrap/Tabs";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { Chart } from "react-google-charts";
import { FilterContext } from "../index";
import { REVIEW_APP_MUTATION, REVIEW_APP_QUERY, REVIEWED_APP_QUERY, REVIEW_APP_EXPORT_QUERY, REVIEWED_APP_EXPORT_QUERY, USED_REVIEW_REVIEWED_APP_QUERY, USED_REVIEW_REVIEWED_APP_EXPORT_QUERY, EXCLUDE_APPS_FROM_IDLE_TIME_QUERY, CHANGE_IDLE_APP_STATUS_MUTATION } from "./query";
import "./ReviewUsage.css";
import Loader from "./../Loader/Loader";
import { findDemoOrLiveSite } from "../SideMenu/Header";
import { convertSecToHoursAndMinutesWithTextShortForm, colors } from "../utils";
import { toast } from "react-toastify";
import { HiDownload } from "react-icons/hi";
import Excel from "exceljs/dist/es5/exceljs.browser";
import { saveAs } from "file-saver";
import { VscLoading } from "react-icons/vsc";
import { MdClose } from "react-icons/md";
import Alert from "react-bootstrap/Alert";
import Modal from "react-bootstrap/Modal";
var UNREVIEW_LIMIT = 20000;
var LIMIT = 10;
var ReviewUsage = function ReviewUsage(props) {
  var _React$useContext = React.useContext(FilterContext),
    teamId = _React$useContext.teamId,
    organisationId = _React$useContext.organisationId,
    organisationUserCount = _React$useContext.organisationUserCount,
    role = _React$useContext.role,
    organisationBilling = _React$useContext.organisationBilling,
    teamName = _React$useContext.teamName,
    from = _React$useContext.from,
    organisationSettings = _React$useContext.organisationSettings,
    organisationStatus = _React$useContext.organisationStatus;

  //  WORKFOLIO MAINTENANCE REDIRECTION
  // React.useEffect(() => {
  //   props?.history.push("/workfolio-maintenance");
  // }, []);
  React.useEffect(function () {
    if (from == "web" && role == "Member") {
      props === null || props === void 0 ? void 0 : props.history.push("/my-work");
    }
  }, [role]);
  React.useEffect(function () {
    if (((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == null || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) === "stopped") && role != "Member" || organisationStatus == "inactive") {
      props === null || props === void 0 ? void 0 : props.history.push("/billing");
    }
  }, [organisationBilling]);
  var loadPage = role === "Admin" || organisationSettings.allowHeadsToReviewApps && role == "Head" || role === null;
  var Redirect = props.redirect,
    location = props.location;
  return /*#__PURE__*/React.createElement("div", {
    className: "review-usage-root"
  }, /*#__PURE__*/React.createElement(ReviewLatestAppAndWebsite, {
    teamId: teamId,
    organisationId: organisationId,
    location: location,
    organisationUserCount: organisationUserCount,
    loadPage: loadPage,
    Redirect: Redirect,
    teamName: teamName,
    organisationBilling: organisationBilling,
    organisationSettings: organisationSettings,
    role: role
  }));
};
var ReviewLatestAppAndWebsite = function ReviewLatestAppAndWebsite(props) {
  var _appsWebsiteListingDa5, _appsWebsiteListingDa6, _appsWebsiteListingDa7, _data$reviewedApps, _data$reviewedApps$re, _data$reviewedApps2, _data$reviewedApps2$r, _topUsedAppData$topUs, _topUsedAppData$topUs2, _topUsedAppData$topUs3, _topUsedAppData$topUs4, _appsWebsiteListingDa12, _data$reviewedApps3, _topUsedAppData$topUs5;
  var teamId = props.teamId,
    organisationId = props.organisationId,
    location = props.location,
    organisationUserCount = props.organisationUserCount,
    loadPage = props.loadPage,
    Redirect = props.Redirect,
    teamName = props.teamName,
    organisationBilling = props.organisationBilling,
    organisationSettings = props.organisationSettings,
    role = props.role;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    appLength = _React$useState2[0],
    setAppLength = _React$useState2[1];
  var _React$useState3 = React.useState("apps"),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    activeTab = _React$useState4[0],
    setActiveTab = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isReviewLoadingMore = _React$useState6[0],
    setReviewIsLoadingMore = _React$useState6[1];
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isReviewAllLoaded = _React$useState8[0],
    setReviewIsAllLoaded = _React$useState8[1];
  var _React$useState9 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    isReviewedLoadingMore = _React$useState10[0],
    setReviewedIsLoadingMore = _React$useState10[1];
  var _React$useState11 = React.useState(false),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    isReviewedAllLoaded = _React$useState12[0],
    setReviewedIsAllLoaded = _React$useState12[1];
  var _React$useState13 = React.useState(null),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    reviewSearch = _React$useState14[0],
    setReviewSearch = _React$useState14[1];
  var _React$useState15 = React.useState(null),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    reviewedSearch = _React$useState16[0],
    setReviewedSearch = _React$useState16[1];
  var _React$useState17 = React.useState(1),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    reviewPageOffset = _React$useState18[0],
    setReviewPageOffset = _React$useState18[1];
  var _React$useState19 = React.useState(false),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    isTopUsedAppLoadingMore = _React$useState20[0],
    setTopUsedAppIsLoadingMore = _React$useState20[1];
  var _React$useState21 = React.useState(false),
    _React$useState22 = _slicedToArray(_React$useState21, 2),
    isTopUsedAppAllLoaded = _React$useState22[0],
    setTopUsedAppIsAllLoaded = _React$useState22[1];
  var _React$useState23 = React.useState(null),
    _React$useState24 = _slicedToArray(_React$useState23, 2),
    topUsedAppSearch = _React$useState24[0],
    setTopUsedAppSearch = _React$useState24[1];
  var _React$useState25 = React.useState(false),
    _React$useState26 = _slicedToArray(_React$useState25, 2),
    isExcludeIdleAppLoadingMore = _React$useState26[0],
    setExcludeIdleAppIsLoadingMore = _React$useState26[1];
  var _React$useState27 = React.useState(false),
    _React$useState28 = _slicedToArray(_React$useState27, 2),
    isExcludeIdleAppAllLoaded = _React$useState28[0],
    setExcludeIdleAppIsAllLoaded = _React$useState28[1];
  var _React$useState29 = React.useState(null),
    _React$useState30 = _slicedToArray(_React$useState29, 2),
    excludeIdleAppSearch = _React$useState30[0],
    setExcludeIdleAppSearch = _React$useState30[1];
  var _React$useState31 = React.useState(false),
    _React$useState32 = _slicedToArray(_React$useState31, 2),
    exportButton = _React$useState32[0],
    setExportButton = _React$useState32[1];
  var _useQuery = useQuery(REVIEW_APP_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        limit: UNREVIEW_LIMIT,
        offset: 0,
        // Frontend search only for this query, so always request unfiltered list.
        searchText: reviewSearch,
        role: role
      },
      skip: !teamId || !loadPage
    }),
    appsWebsiteListingData = _useQuery.data,
    appsWebsiteListingError = _useQuery.error,
    appsWebsiteListingLoading = _useQuery.loading,
    refetch = _useQuery.refetch,
    reviewFetchMore = _useQuery.fetchMore;

  // const {
  //   data: appCountData,
  //   error: appCountError,
  //   loading: appCountLoading,
  //   refetch: appCountRefetch,
  // } = useQuery(APPS_COUNT_QUERY, {
  //   variables: {
  //     organisationId,
  //     teamId,
  //     role,
  //   },
  //   skip: !teamId || !loadPage,
  // });

  React.useEffect(function () {
    refetch === null || refetch === void 0 ? void 0 : refetch();
    //appCountRefetch?.();
  }, [location.key]);
  var _useLazyQuery = useLazyQuery(REVIEWED_APP_QUERY),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
    getReviewed = _useLazyQuery2[0],
    _useLazyQuery2$ = _useLazyQuery2[1],
    reviewedLoading = _useLazyQuery2$.loading,
    data = _useLazyQuery2$.data,
    fetchMore = _useLazyQuery2$.fetchMore;
  var _useLazyQuery3 = useLazyQuery(USED_REVIEW_REVIEWED_APP_QUERY, {
      // cache-and-network: refetch fresh data whenever the query (re)runs — e.g.
      // switching back to a previously-loaded team — so review-status changes show.
      // nextFetchPolicy cache-first keeps subsequent reads on the cache so fetchMore
      // pagination accumulates instead of the base query re-firing with offset 0.
      // No notifyOnNetworkStatusChange: keeps `loading` true only on the initial
      // load, so fetchMore / background refetch don't replace the whole list with
      // the main loader (the bottom spinner uses isTopUsedAppLoadingMore instead).
      fetchPolicy: "cache-and-network",
      nextFetchPolicy: "cache-first"
    }),
    _useLazyQuery4 = _slicedToArray(_useLazyQuery3, 2),
    getTopUsedApp = _useLazyQuery4[0],
    _useLazyQuery4$ = _useLazyQuery4[1],
    topUsedAppLoading = _useLazyQuery4$.loading,
    topUsedAppData = _useLazyQuery4$.data,
    topUsedAppFetchMore = _useLazyQuery4$.fetchMore;
  var _useLazyQuery5 = useLazyQuery(REVIEWED_APP_EXPORT_QUERY, {
      // A rate-limited export (429) never returns data, and this screen's
      // spinner is cleared on data only - without this the export button
      // stays loading until the page is reloaded. The message itself is
      // shown by the errorLink in apollo/apollo-config.js.
      onError: function onError() {
        setExportButton(false);
      }
    }),
    _useLazyQuery6 = _slicedToArray(_useLazyQuery5, 2),
    getReviewExport = _useLazyQuery6[0],
    _useLazyQuery6$ = _useLazyQuery6[1],
    exportReviewLoading = _useLazyQuery6$.loading,
    exportReviewData = _useLazyQuery6$.data;
  var _useLazyQuery7 = useLazyQuery(REVIEW_APP_EXPORT_QUERY, {
      // A rate-limited export (429) never returns data, and this screen's
      // spinner is cleared on data only - without this the export button
      // stays loading until the page is reloaded. The message itself is
      // shown by the errorLink in apollo/apollo-config.js.
      onError: function onError() {
        setExportButton(false);
      }
    }),
    _useLazyQuery8 = _slicedToArray(_useLazyQuery7, 2),
    getUnReviewExport = _useLazyQuery8[0],
    _useLazyQuery8$ = _useLazyQuery8[1],
    exportUnReviewLoading = _useLazyQuery8$.loading,
    exportUnReviewData = _useLazyQuery8$.data;
  var _useLazyQuery9 = useLazyQuery(USED_REVIEW_REVIEWED_APP_EXPORT_QUERY, {
      // A rate-limited export (429) never returns data, and this screen's
      // spinner is cleared on data only - without this the export button
      // stays loading until the page is reloaded. The message itself is
      // shown by the errorLink in apollo/apollo-config.js.
      onError: function onError() {
        setExportButton(false);
      }
    }),
    _useLazyQuery10 = _slicedToArray(_useLazyQuery9, 2),
    getTopAppExport = _useLazyQuery10[0],
    _useLazyQuery10$ = _useLazyQuery10[1],
    exportTopAppLoading = _useLazyQuery10$.loading,
    exportTopAppData = _useLazyQuery10$.data;
  var _useLazyQuery11 = useLazyQuery(EXCLUDE_APPS_FROM_IDLE_TIME_QUERY),
    _useLazyQuery12 = _slicedToArray(_useLazyQuery11, 2),
    getExcludeIdleApps = _useLazyQuery12[0],
    _useLazyQuery12$ = _useLazyQuery12[1],
    excludeIdleAppsLoading = _useLazyQuery12$.loading,
    excludeIdleAppsData = _useLazyQuery12$.data;
  var csvUnReviewData = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var _exportUnReviewData$r;
    var dataValues, wb, ws, buf, fileName;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          dataValues = exportUnReviewData === null || exportUnReviewData === void 0 ? void 0 : (_exportUnReviewData$r = exportUnReviewData.reviewAppsExport) === null || _exportUnReviewData$r === void 0 ? void 0 : _exportUnReviewData$r.reviewApp;
          if (dataValues) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return", []);
        case 3:
          wb = new Excel.Workbook();
          ws = wb.addWorksheet();
          ws.columns = [{
            header: "App Name",
            key: "title",
            width: 70,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Status",
            key: "productivityStatus",
            width: 30,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }];
          dataValues.map(function (d, index) {
            var title = d.title,
              productivityStatus = d.productivityStatus,
              appType = d.appType;
            ws.addRow({
              title: title,
              productivityStatus: "unreviewed"
              //appType,
            });
          });
          ws.getCell("A1").font = {
            bold: true
          };
          ws.getCell("B1").font = {
            bold: true
          };
          _context.next = 11;
          return wb.xlsx.writeBuffer();
        case 11:
          buf = _context.sent;
          fileName = "workfolio-unreviewed-apps.xlsx";
          saveAs(new Blob([buf]), fileName);
          setExportButton(false);
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), [exportUnReviewData]);
  var csvReviewData = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var _exportReviewData$rev;
    var dataValues, wb, ws, buf, fileName;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          dataValues = exportReviewData === null || exportReviewData === void 0 ? void 0 : (_exportReviewData$rev = exportReviewData.reviewedAppsExport) === null || _exportReviewData$rev === void 0 ? void 0 : _exportReviewData$rev.reviewedApp;
          if (dataValues) {
            _context2.next = 3;
            break;
          }
          return _context2.abrupt("return", []);
        case 3:
          wb = new Excel.Workbook();
          ws = wb.addWorksheet();
          ws.columns = [{
            header: "App Name",
            key: "title",
            width: 70,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Status",
            key: "productivityStatus",
            width: 30,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }];
          dataValues.map(function (d, index) {
            var title = d.title,
              productivityStatus = d.productivityStatus,
              appType = d.appType;
            ws.addRow({
              title: title,
              productivityStatus: productivityStatus
              //appType
            });
          });
          ws.getCell("A1").font = {
            bold: true
          };
          ws.getCell("B1").font = {
            bold: true
          };
          _context2.next = 11;
          return wb.xlsx.writeBuffer();
        case 11:
          buf = _context2.sent;
          fileName = "workfolio-reviewed-apps.xlsx";
          saveAs(new Blob([buf]), fileName);
          setExportButton(false);
        case 15:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })), [exportReviewData]);
  var csvTopData = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var _exportTopAppData$top;
    var dataValues, wb, ws, buf, fileName;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          dataValues = exportTopAppData === null || exportTopAppData === void 0 ? void 0 : (_exportTopAppData$top = exportTopAppData.topUsedReviewReviewedAppsExport) === null || _exportTopAppData$top === void 0 ? void 0 : _exportTopAppData$top.topUsedReviewReviewedApp;
          if (dataValues) {
            _context3.next = 3;
            break;
          }
          return _context3.abrupt("return", []);
        case 3:
          wb = new Excel.Workbook();
          ws = wb.addWorksheet();
          ws.columns = [{
            header: "App Name",
            key: "title",
            width: 50,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Status",
            key: "productivityStatus",
            width: 25,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Total worked hours",
            key: "totalSecInHour",
            width: 25,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }

          // { header: "Type", key: "appType", style: { alignment: { vertical: "middle", horizontal: "left" } } },
          ];
          dataValues.map(function (d, index) {
            var title = d.title,
              productivityStatus = d.productivityStatus,
              appType = d.appType,
              totalSecInHour = d.totalSecInHour;
            ws.addRow({
              title: title,
              productivityStatus: productivityStatus,
              totalSecInHour: totalSecInHour
              //appType
            });
          });
          ws.getCell("A1").font = {
            bold: true
          };
          ws.getCell("B1").font = {
            bold: true
          };
          ws.getCell("C1").font = {
            bold: true
          };
          _context3.next = 12;
          return wb.xlsx.writeBuffer();
        case 12:
          buf = _context3.sent;
          fileName = "workfolio-top-used-apps.xlsx";
          saveAs(new Blob([buf]), fileName);
          setExportButton(false);
        case 16:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  })), [exportTopAppData]);
  React.useEffect(function () {
    csvReviewData();
  }, [exportReviewData]);
  React.useEffect(function () {
    csvUnReviewData();
  }, [exportUnReviewData]);
  React.useEffect(function () {
    csvTopData();
  }, [exportTopAppData]);
  React.useEffect(function () {
    if (activeTab == "apps") {
      setReviewSearch(null);
    } else if (activeTab === "reviewedAppsAndWebsites") {
      getReviewed({
        variables: {
          organisationId: organisationId,
          teamId: teamId,
          limit: LIMIT,
          offset: 0,
          searchText: null,
          role: role
        }
      });
      setReviewedSearch(null);
    } else if (activeTab === "topApps") {
      getTopUsedApp({
        variables: {
          organisationId: organisationId,
          teamId: teamId,
          limit: LIMIT,
          offset: 0,
          searchText: null,
          timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
          role: role
        }
      });
      setTopUsedAppSearch(null);
    } else if (activeTab === "excludeAppsFromIdleTime") {
      getExcludeIdleApps({
        variables: {
          organisationId: organisationId,
          teamId: teamId,
          searchText: null,
          role: role
        }
      });
      setExcludeIdleAppSearch(null);
    }
  }, [teamId]);
  React.useEffect(function () {
    setReviewIsAllLoaded === null || setReviewIsAllLoaded === void 0 ? void 0 : setReviewIsAllLoaded(false);
    setReviewedIsAllLoaded === null || setReviewedIsAllLoaded === void 0 ? void 0 : setReviewedIsAllLoaded(false);
    setTopUsedAppIsAllLoaded === null || setTopUsedAppIsAllLoaded === void 0 ? void 0 : setTopUsedAppIsAllLoaded(false);
  }, [teamId, activeTab]);
  useEffect(function () {
    if (activeTab === "reviewedAppsAndWebsites") {
      var _appsWebsiteListingDa, _appsWebsiteListingDa2;
      setAppLength((appsWebsiteListingData === null || appsWebsiteListingData === void 0 ? void 0 : (_appsWebsiteListingDa = appsWebsiteListingData.apps) === null || _appsWebsiteListingDa === void 0 ? void 0 : (_appsWebsiteListingDa2 = _appsWebsiteListingDa.reviewedApp) === null || _appsWebsiteListingDa2 === void 0 ? void 0 : _appsWebsiteListingDa2.length) === 0 ? true : false);
    } else if (activeTab === "apps") {
      var _appsWebsiteListingDa3, _appsWebsiteListingDa4;
      setAppLength((appsWebsiteListingData === null || appsWebsiteListingData === void 0 ? void 0 : (_appsWebsiteListingDa3 = appsWebsiteListingData.apps) === null || _appsWebsiteListingDa3 === void 0 ? void 0 : (_appsWebsiteListingDa4 = _appsWebsiteListingDa3.reviewApp) === null || _appsWebsiteListingDa4 === void 0 ? void 0 : _appsWebsiteListingDa4.length) === 0 ? true : false);
    }
  }, [appsWebsiteListingData === null || appsWebsiteListingData === void 0 ? void 0 : (_appsWebsiteListingDa5 = appsWebsiteListingData.apps) === null || _appsWebsiteListingDa5 === void 0 ? void 0 : _appsWebsiteListingDa5.reviewApp]);
  if (!loadPage) {
    return /*#__PURE__*/React.createElement(Redirect, {
      to: "/"
    });
  }
  if ((appsWebsiteListingData === null || appsWebsiteListingData === void 0 ? void 0 : (_appsWebsiteListingDa6 = appsWebsiteListingData.reviewApps) === null || _appsWebsiteListingDa6 === void 0 ? void 0 : (_appsWebsiteListingDa7 = _appsWebsiteListingDa6.reviewApp) === null || _appsWebsiteListingDa7 === void 0 ? void 0 : _appsWebsiteListingDa7.length) == 0 && !isReviewAllLoaded) {
    setReviewIsAllLoaded(true);
  }
  if ((data === null || data === void 0 ? void 0 : (_data$reviewedApps = data.reviewedApps) === null || _data$reviewedApps === void 0 ? void 0 : (_data$reviewedApps$re = _data$reviewedApps.reviewedApp) === null || _data$reviewedApps$re === void 0 ? void 0 : _data$reviewedApps$re.length) !== 0 && (data === null || data === void 0 ? void 0 : (_data$reviewedApps2 = data.reviewedApps) === null || _data$reviewedApps2 === void 0 ? void 0 : (_data$reviewedApps2$r = _data$reviewedApps2.reviewedApp) === null || _data$reviewedApps2$r === void 0 ? void 0 : _data$reviewedApps2$r.length) < LIMIT && !isReviewedAllLoaded) {
    setReviewedIsAllLoaded(true);
  }
  if ((topUsedAppData === null || topUsedAppData === void 0 ? void 0 : (_topUsedAppData$topUs = topUsedAppData.topUsedReviewReviewedApps) === null || _topUsedAppData$topUs === void 0 ? void 0 : (_topUsedAppData$topUs2 = _topUsedAppData$topUs.topUsedReviewReviewedApp) === null || _topUsedAppData$topUs2 === void 0 ? void 0 : _topUsedAppData$topUs2.length) !== 0 && (topUsedAppData === null || topUsedAppData === void 0 ? void 0 : (_topUsedAppData$topUs3 = topUsedAppData.topUsedReviewReviewedApps) === null || _topUsedAppData$topUs3 === void 0 ? void 0 : (_topUsedAppData$topUs4 = _topUsedAppData$topUs3.topUsedReviewReviewedApp) === null || _topUsedAppData$topUs4 === void 0 ? void 0 : _topUsedAppData$topUs4.length) < LIMIT && !isTopUsedAppAllLoaded) {
    setTopUsedAppIsAllLoaded(true);
  }
  var handleTabSelect = function handleTabSelect(key) {
    var status = false;
    if (key === "reviewedAppsAndWebsites") {
      var _appsWebsiteListingDa8, _appsWebsiteListingDa9;
      status = (appsWebsiteListingData === null || appsWebsiteListingData === void 0 ? void 0 : (_appsWebsiteListingDa8 = appsWebsiteListingData.apps) === null || _appsWebsiteListingDa8 === void 0 ? void 0 : (_appsWebsiteListingDa9 = _appsWebsiteListingDa8.reviewedApp) === null || _appsWebsiteListingDa9 === void 0 ? void 0 : _appsWebsiteListingDa9.length) === 0 ? true : false;
    } else if (key === "apps") {
      var _appsWebsiteListingDa10, _appsWebsiteListingDa11;
      status = (appsWebsiteListingData === null || appsWebsiteListingData === void 0 ? void 0 : (_appsWebsiteListingDa10 = appsWebsiteListingData.apps) === null || _appsWebsiteListingDa10 === void 0 ? void 0 : (_appsWebsiteListingDa11 = _appsWebsiteListingDa10.reviewApp) === null || _appsWebsiteListingDa11 === void 0 ? void 0 : _appsWebsiteListingDa11.length) === 0 ? true : false;
    }
    if (key === "reviewedAppsAndWebsites") {
      getReviewed({
        variables: {
          organisationId: organisationId,
          teamId: teamId,
          limit: LIMIT,
          offset: 0,
          searchText: null,
          role: role
        }
      });
    }
    if (key === "topApps") {
      getTopUsedApp({
        variables: {
          organisationId: organisationId,
          teamId: teamId,
          limit: LIMIT,
          offset: 0,
          searchText: null,
          timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
          role: role
        }
      });
    }
    if (key === "excludeAppsFromIdleTime") {
      getExcludeIdleApps({
        variables: {
          organisationId: organisationId,
          teamId: teamId,
          searchText: null,
          role: role
        }
      });
    }
    setAppLength(status);
    setActiveTab(key);
  };
  var getExportData = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            if (activeTab == "apps") {
              setExportButton(true);
              getUnReviewExport({
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  role: role
                }
              });
            } else if (activeTab == "topApps") {
              setExportButton(true);
              getTopAppExport({
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
                  role: role
                }
              });
            } else {
              setExportButton(true);
              getReviewExport({
                variables: {
                  organisationId: organisationId,
                  teamId: teamId,
                  role: role
                }
              });
            }
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function getExportData() {
      return _ref4.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "review-page-heading-text-div"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h5", {
    className: "text-secondary mb-2"
  }, "Review apps & websites for", " ", /*#__PURE__*/React.createElement("span", {
    className: "text-secondary mb-2 review-usage-root-title"
  }, teamId == "all" && role == "Admin" ? "Organization" : teamId == "all" && role == "Head" ? "All Team" : teamName)), /*#__PURE__*/React.createElement("p", {
    className: "review-page-note-text"
  }, "Note: ", /*#__PURE__*/React.createElement("div", null, "Filter the team name to review the apps & websites in team-wise."), " ", /*#__PURE__*/React.createElement("div", null, "The status change may take up to 100 minutes to reflect and will be applied to future data."))), activeTab != "excludeAppsFromIdleTime" ? /*#__PURE__*/React.createElement("div", {
    className: "review-page-export-div"
  }, (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) != "free" ? !exportButton ? /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      getExportData();
    }
    // className="daily-attendance-filter-download-icon-btn"
  }, /*#__PURE__*/React.createElement(HiDownload, {
    className: "daily-attendance-filter-download-icon"
  }), " ", activeTab == "reviewedAppsAndWebsites" ? "Download Reviewed Apps" : activeTab == "topApps" ? "Download Top Used Apps" : "Download Unreviewed Apps") : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary"
    // className="daily-attendance-filter-download-icon-btn"
    ,
    disabled: exportButton
  }, /*#__PURE__*/React.createElement(HiDownload, {
    className: "daily-attendance-filter-download-icon"
  }), "Downloading") : /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Please upgrade your plan to export report")
  }, /*#__PURE__*/React.createElement("div", {
    className: "timesheet-export-button-header disable-timesheet"
  }, /*#__PURE__*/React.createElement(HiDownload, {
    className: "timesheet-download-icon"
  }), " Export"))) : null), /*#__PURE__*/React.createElement("div", {
    className: "py-2 review-usage-root-list ".concat(appLength ? "review-usage-root-list-no-data" : null)
  }, /*#__PURE__*/React.createElement(Tabs
  // defaultActiveKey="apps"
  , {
    defaultActiveKey: "apps",
    onSelect: function onSelect(e) {
      handleTabSelect(e);
      setReviewSearch(null);
      setReviewedSearch(null);
    }
  }, /*#__PURE__*/React.createElement(Tab, {
    eventKey: "apps",
    title: /*#__PURE__*/React.createElement("span", null, "Unreviewed apps", " ")
  }, /*#__PURE__*/React.createElement(AppsAndWebsites, {
    name: "apps",
    list: appsWebsiteListingData === null || appsWebsiteListingData === void 0 ? void 0 : (_appsWebsiteListingDa12 = appsWebsiteListingData.reviewApps) === null || _appsWebsiteListingDa12 === void 0 ? void 0 : _appsWebsiteListingDa12.reviewApp,
    organisationId: organisationId,
    teamId: teamId,
    activeTab: activeTab,
    reviewFetchMore: reviewFetchMore,
    appsWebsiteListingLoading: appsWebsiteListingLoading,
    isReviewLoadingMore: isReviewLoadingMore,
    setReviewIsLoadingMore: setReviewIsLoadingMore,
    isReviewAllLoaded: isReviewAllLoaded,
    setReviewIsAllLoaded: setReviewIsAllLoaded,
    appsWebsiteListingError: appsWebsiteListingError,
    reviewSearch: reviewSearch,
    setReviewSearch: setReviewSearch,
    organisationUserCount: organisationUserCount,
    role: role,
    reviewPageOffset: reviewPageOffset,
    setReviewPageOffset: setReviewPageOffset
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "reviewedAppsAndWebsites",
    title: /*#__PURE__*/React.createElement("span", null, "Reviewed apps", " ")
  }, /*#__PURE__*/React.createElement(AppsAndWebsitesReviewed, {
    name: "Reviewed apps"
    //list={appsWebsiteListingData?.apps?.reviewedApp}
    ,
    list: data === null || data === void 0 ? void 0 : (_data$reviewedApps3 = data.reviewedApps) === null || _data$reviewedApps3 === void 0 ? void 0 : _data$reviewedApps3.reviewedApp,
    organisationId: organisationId,
    teamId: teamId,
    fetchMore: fetchMore,
    getReviewed: getReviewed,
    reviewedLoading: reviewedLoading,
    isReviewedLoadingMore: isReviewedLoadingMore,
    setReviewedIsLoadingMore: setReviewedIsLoadingMore,
    isReviewedAllLoaded: isReviewedAllLoaded,
    setReviewedIsAllLoaded: setReviewedIsAllLoaded,
    reviewedSearch: reviewedSearch,
    setReviewedSearch: setReviewedSearch,
    role: role
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "topApps",
    title: /*#__PURE__*/React.createElement("span", null, "Top used apps")
  }, /*#__PURE__*/React.createElement(TopUsedApp, {
    name: "Top used apps",
    list: topUsedAppData === null || topUsedAppData === void 0 ? void 0 : (_topUsedAppData$topUs5 = topUsedAppData.topUsedReviewReviewedApps) === null || _topUsedAppData$topUs5 === void 0 ? void 0 : _topUsedAppData$topUs5.topUsedReviewReviewedApp,
    organisationId: organisationId,
    teamId: teamId,
    fetchMore: topUsedAppFetchMore,
    getTopUsedApp: getTopUsedApp,
    topUsedAppLoading: topUsedAppLoading,
    isTopUsedAppLoadingMore: isTopUsedAppLoadingMore,
    setTopUsedAppIsLoadingMore: setTopUsedAppIsLoadingMore,
    isTopUsedAppAllLoaded: isTopUsedAppAllLoaded,
    setTopUsedAppIsAllLoaded: setTopUsedAppIsAllLoaded,
    topUsedAppSearch: topUsedAppSearch,
    setTopUsedAppSearch: setTopUsedAppSearch,
    organisationSettings: organisationSettings,
    role: role
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "excludeAppsFromIdleTime",
    title: /*#__PURE__*/React.createElement("span", null, "Exclude apps from idle time")
  }, /*#__PURE__*/React.createElement(ExcludeAppsFromIdleTime, {
    name: "Exclude apps from idle time",
    list: excludeIdleAppsData === null || excludeIdleAppsData === void 0 ? void 0 : excludeIdleAppsData.excludeAppsFromIdleTime,
    organisationId: organisationId,
    teamId: teamId,
    getExcludeIdleApps: getExcludeIdleApps,
    excludeIdleAppsLoading: excludeIdleAppsLoading,
    isExcludeIdleAppLoadingMore: isExcludeIdleAppLoadingMore,
    setExcludeIdleAppIsLoadingMore: setExcludeIdleAppIsLoadingMore,
    isExcludeIdleAppAllLoaded: isExcludeIdleAppAllLoaded,
    setExcludeIdleAppIsAllLoaded: setExcludeIdleAppIsAllLoaded,
    excludeIdleAppSearch: excludeIdleAppSearch,
    setExcludeIdleAppSearch: setExcludeIdleAppSearch,
    organisationSettings: organisationSettings,
    role: role
  })))));
};
function AppsAndWebsites(props) {
  var list = props.list,
    organisationId = props.organisationId,
    teamId = props.teamId,
    name = props.name,
    reviewFetchMore = props.reviewFetchMore,
    appsWebsiteListingLoading = props.appsWebsiteListingLoading,
    isReviewLoadingMore = props.isReviewLoadingMore,
    setReviewIsLoadingMore = props.setReviewIsLoadingMore,
    isReviewAllLoaded = props.isReviewAllLoaded,
    setReviewIsAllLoaded = props.setReviewIsAllLoaded,
    appsWebsiteListingError = props.appsWebsiteListingError,
    reviewSearch = props.reviewSearch,
    setReviewSearch = props.setReviewSearch,
    organisationUserCount = props.organisationUserCount,
    role = props.role,
    reviewPageOffset = props.reviewPageOffset,
    setReviewPageOffset = props.setReviewPageOffset;
  var filteredList = list;

  // reviewSearch
  //   ? list?.filter((item) => item?.title?.toLowerCase().includes(reviewSearch.toLowerCase()))
  //   : list;
  var _React$useState33 = React.useState(null),
    _React$useState34 = _slicedToArray(_React$useState33, 2),
    searchInput = _React$useState34[0],
    setSearchInput = _React$useState34[1];
  var _React$useState35 = React.useState(null),
    _React$useState36 = _slicedToArray(_React$useState35, 2),
    onHoverStatus = _React$useState36[0],
    setOnHoverStatus = _React$useState36[1];
  var _React$useState37 = React.useState(null),
    _React$useState38 = _slicedToArray(_React$useState37, 2),
    copyReviewStatus = _React$useState38[0],
    setCopyReviewStatus = _React$useState38[1];
  var _useMutation = useMutation(REVIEW_APP_MUTATION),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    addAppProductivityStatus = _useMutation2[0],
    addAppProductivityStatusLoading = _useMutation2[1].loading;
  function handleLoadMore() {
    if (reviewSearch) return;
    if (appsWebsiteListingLoading) return;
    setReviewIsLoadingMore(true);
    var pageOffset = reviewPageOffset * UNREVIEW_LIMIT;
    reviewFetchMore({
      variables: {
        offset: pageOffset
      },
      updateQuery: function updateQuery(prev, _ref5) {
        var fetchMoreResult = _ref5.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if (fetchMoreResult.reviewApps.reviewApp.length == 0 && !isReviewAllLoaded) {
          setReviewIsAllLoaded(true);
        }
        setReviewIsLoadingMore(false);
        var NewFilterData = [];
        fetchMoreResult.reviewApps.reviewApp.forEach(function (newReviewApp) {
          var found = prev.reviewApps.reviewApp.find(function (item) {
            return item.title === newReviewApp.title;
          });
          if (!found) {
            // If not found, add validation.
            NewFilterData.push(newReviewApp);
          }
        });
        return _objectSpread(_objectSpread({}, prev), {}, {
          reviewApps: _objectSpread(_objectSpread({}, prev.reviewApps), {}, {
            reviewApp: [].concat(_toConsumableArray(prev.reviewApps.reviewApp), NewFilterData)
          })
        });
      }
    });
    setReviewPageOffset(function (prev) {
      return prev + 1;
    });
  }
  var handleReview = React.useCallback( /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(newStatus, app, teamId, role) {
      var appName, appType, appCategory, _response$data$addApp, response;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            if (!addAppProductivityStatusLoading) {
              _context5.next = 2;
              break;
            }
            return _context5.abrupt("return", null);
          case 2:
            appName = app.title, appType = app.appType, appCategory = app.appCategory;
            _context5.prev = 3;
            _context5.next = 6;
            return addAppProductivityStatus({
              variables: {
                appName: appName,
                appType: appType,
                appCategory: appCategory,
                productivityStatus: newStatus,
                organisationId: organisationId,
                teamId: teamId === "all" ? null : teamId,
                canBeIdle: false,
                role: role
              }
            });
          case 6:
            response = _context5.sent;
            if (response && response !== null && response !== void 0 && response.data && response !== null && response !== void 0 && (_response$data$addApp = response.data.addAppProductivityStatus) !== null && _response$data$addApp !== void 0 && _response$data$addApp.appName) {
              toast.success("Review status updated successfully!");
            } else {
              toast.success("Error, try again!");
            }
            _context5.next = 14;
            break;
          case 10:
            _context5.prev = 10;
            _context5.t0 = _context5["catch"](3);
            console.log(_context5.t0);
            toast.success("Error, try again!");
          case 14:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[3, 10]]);
    }));
    return function (_x, _x2, _x3, _x4) {
      return _ref6.apply(this, arguments);
    };
  }(), []);
  return /*#__PURE__*/React.createElement("div", {
    className: "p-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "review-usage-search-root-div ".concat(window.innerWidth < 768 ? "review-usage-search-root-div-mobile" : "")
  }, /*#__PURE__*/React.createElement(FormControl, {
    onChange: function onChange(e) {
      setSearchInput(e.target.value);
      if (e.target.value == "") {
        setReviewSearch(null);
        setReviewIsAllLoaded === null || setReviewIsAllLoaded === void 0 ? void 0 : setReviewIsAllLoaded(false);
        setReviewPage(1);
      }
    },
    onKeyPress: function onKeyPress(event) {
      if (event.key === "Enter") {
        if (searchInput == "") {
          setReviewSearch(null);
          setReviewIsAllLoaded === null || setReviewIsAllLoaded === void 0 ? void 0 : setReviewIsAllLoaded(false);
          setReviewPage(1);
        } else {
          setReviewSearch(searchInput);
          setReviewPage(1);
        }
      }
    },
    placeholder: "Search ".concat(name),
    value: searchInput ? searchInput : "",
    className: "review-usage-search-root-search-input"
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "review-usage-search-root-search-button-div ".concat(window.innerWidth < 768 ? "review-usage-search-root-search-button-div-mobile" : ""),
    onClick: function onClick() {
      if (searchInput == "") {
        setReviewSearch(null);
        setReviewIsAllLoaded === null || setReviewIsAllLoaded === void 0 ? void 0 : setReviewIsAllLoaded(false);
        setReviewPage(1);
      } else {
        setReviewSearch(searchInput);
        setReviewPage(1);
      }
    },
    disabled: appsWebsiteListingLoading
  }, window.innerWidth < 768 ? "Search" : "Search Apps")), /*#__PURE__*/React.createElement("div", {
    className: "review-usage-root-listing"
  }, appsWebsiteListingLoading ? /*#__PURE__*/React.createElement(Loader, null) : appsWebsiteListingError ? /*#__PURE__*/React.createElement("div", {
    className: "common-err-refresh-text"
  }, "Something went wrong, please refresh the page.") : filteredList && filteredList.length ? filteredList.map(function (item) {
    var title = item.title,
      productivityStatus = item.productivityStatus,
      icon = item.icon;
    return /*#__PURE__*/React.createElement("div", {
      className: "bg-light rounded-lg mb-2 p-2 review-usage-root-listing-whole-div",
      key: "".concat(title, "-review-app"),
      onMouseEnter: function onMouseEnter() {
        setOnHoverStatus(title);
      },
      onMouseLeave: function onMouseLeave() {
        setOnHoverStatus(null);
        setCopyReviewStatus(null);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "d-flex align-items-center flex-grow-1 review-usage-root-listing-whole-div-names"
    }, /*#__PURE__*/React.createElement("img", {
      className: "review-usage-root-listing-card-content-avatar",
      src: icon
    }), /*#__PURE__*/React.createElement("div", {
      className: "flex-grow-1"
    }, /*#__PURE__*/React.createElement("div", {
      className: "review-usage-root-listing-card-content-title"
    }, title, onHoverStatus == title && copyReviewStatus == null ? /*#__PURE__*/React.createElement("a", {
      className: "review-usage-root-listing-card-content-copy-button",
      onClick: function onClick() {
        copyToClipboard(title, setCopyReviewStatus);
      }
    }, "Copy") : onHoverStatus == title && copyReviewStatus == title ? /*#__PURE__*/React.createElement("span", {
      className: "review-usage-root-listing-card-content-copied-status"
    }, "Copied") : null))), /*#__PURE__*/React.createElement(ReviewButtons, {
      productivityStatus: productivityStatus,
      onChange: function onChange(newStatus) {
        return handleReview(newStatus, item, teamId, role);
      }
    }));
  }) : Number(organisationUserCount) <= 1 ? /*#__PURE__*/React.createElement("div", {
    className: "review-usage-root-list-no-text"
  }, "Your teammates need to start using the workfolio desktop app") : reviewSearch ? /*#__PURE__*/React.createElement("div", null, "Your search \"".concat(reviewSearch, "\" is not found in the Unreviewed apps. You can try search in the Reviewed apps")) : /*#__PURE__*/React.createElement("div", {
    className: "review-usage-light-color-no-data"
  }, "No pending apps/sites to review"), !appsWebsiteListingLoading && list && list.length != 0 && !reviewSearch ? /*#__PURE__*/React.createElement("div", {
    className: "review-apps-load-more-button"
  }, !isReviewAllLoaded ? isReviewLoadingMore ? /*#__PURE__*/React.createElement("div", {
    className: "review-apps-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    onClick: function onClick() {
      return handleLoadMore();
    },
    className: "review-usage-load-more-button"
  }, "Load More") : !appsWebsiteListingLoading && list && list.length ? /*#__PURE__*/React.createElement("p", {
    className: "screenshot-load-more-button review-usage-light-color"
  }, "You have seen all the apps") : null) : null));
}
var copyToClipboard = function copyToClipboard(text, setCopyReviewStatus) {
  var ta = document.createElement("textarea");
  ta.innerText = text;
  document.body.appendChild(ta);
  ta.select();
  document.execCommand("copy");
  ta.remove();
  setCopyReviewStatus(text);
};
var copyToClipboardReviewed = function copyToClipboardReviewed(text, setCopyReviewedStatus) {
  var ta = document.createElement("textarea");
  ta.innerText = text;
  document.body.appendChild(ta);
  ta.select();
  document.execCommand("copy");
  ta.remove();
  setCopyReviewedStatus(text);
};
function AppsAndWebsitesReviewed(props) {
  var list = props.list,
    organisationId = props.organisationId,
    teamId = props.teamId,
    name = props.name,
    fetchMore = props.fetchMore,
    getReviewed = props.getReviewed,
    reviewedLoading = props.reviewedLoading,
    isReviewedLoadingMore = props.isReviewedLoadingMore,
    setReviewedIsLoadingMore = props.setReviewedIsLoadingMore,
    isReviewedAllLoaded = props.isReviewedAllLoaded,
    setReviewedIsAllLoaded = props.setReviewedIsAllLoaded,
    reviewedSearch = props.reviewedSearch,
    setReviewedSearch = props.setReviewedSearch,
    role = props.role;
  var _React$useState39 = React.useState(null),
    _React$useState40 = _slicedToArray(_React$useState39, 2),
    onHoverReviewedStatus = _React$useState40[0],
    setOnHoverReviewedStatus = _React$useState40[1];
  var _React$useState41 = React.useState(null),
    _React$useState42 = _slicedToArray(_React$useState41, 2),
    copyReviewedStatus = _React$useState42[0],
    setCopyReviewedStatus = _React$useState42[1];
  var _React$useState43 = React.useState(false),
    _React$useState44 = _slicedToArray(_React$useState43, 2),
    reviewedFetchLoading = _React$useState44[0],
    setReviewedFetchLoading = _React$useState44[1];
  function handleScroll(e) {
    //if (reviewedSearch) return;
    if (reviewedLoading) return;
    setReviewedIsLoadingMore(true);

    // const element = e.target;
    // if (element.scrollHeight - element.scrollTop === element.clientHeight) {
    fetchMore({
      variables: {
        offset: list.length
      },
      updateQuery: function updateQuery(prev, _ref7) {
        var fetchMoreResult = _ref7.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if (fetchMoreResult.reviewedApps.reviewedApp.length < LIMIT && !isReviewedAllLoaded) {
          setReviewedIsAllLoaded(true);
          setReviewedIsLoadingMore(false);
        }
        setReviewedIsLoadingMore(false);
        return _objectSpread(_objectSpread({}, prev), {}, {
          reviewedApps: _objectSpread(_objectSpread({}, prev.reviewedApps), {}, {
            reviewedApp: [].concat(_toConsumableArray(prev.reviewedApps.reviewedApp), _toConsumableArray(fetchMoreResult.reviewedApps.reviewedApp))
          })
        });
      }
    });

    //setLimits(LIMIT + 20);
    // }
  }
  var _useMutation3 = useMutation(REVIEW_APP_MUTATION),
    _useMutation4 = _slicedToArray(_useMutation3, 2),
    addAppProductivityStatus = _useMutation4[0],
    addAppProductivityStatusLoading = _useMutation4[1].loading;
  var handleReview = React.useCallback( /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(newStatus, app, teamId, role) {
      var appName, appType, appCategory;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            if (!addAppProductivityStatusLoading) {
              _context6.next = 2;
              break;
            }
            return _context6.abrupt("return", null);
          case 2:
            appName = app.title, appType = app.appType, appCategory = app.appCategory;
            _context6.prev = 3;
            _context6.next = 6;
            return addAppProductivityStatus({
              variables: {
                appName: appName,
                appType: appType,
                appCategory: appCategory,
                productivityStatus: newStatus,
                organisationId: organisationId,
                teamId: teamId == "all" ? null : teamId,
                canBeIdle: false,
                role: role
              }
            });
          case 6:
            toast.success("Review status updated successfully!");
            _context6.next = 12;
            break;
          case 9:
            _context6.prev = 9;
            _context6.t0 = _context6["catch"](3);
            console.log(_context6.t0);
          case 12:
          case "end":
            return _context6.stop();
        }
      }, _callee6, null, [[3, 9]]);
    }));
    return function (_x5, _x6, _x7, _x8) {
      return _ref8.apply(this, arguments);
    };
  }(), []);
  return /*#__PURE__*/React.createElement("div", {
    className: "p-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "review-usage-search-root-div ".concat(window.innerWidth < 768 ? "review-usage-search-root-div-mobile" : "")
  }, /*#__PURE__*/React.createElement(FormControl, {
    onChange: function onChange(e) {
      setReviewedSearch(e.target.value);
      if (e.target.value == "") {
        getReviewed({
          variables: {
            organisationId: organisationId,
            teamId: teamId,
            limit: LIMIT,
            offset: 0,
            searchText: null,
            role: role
          }
        });
      }
    },
    onKeyPress: function onKeyPress(event) {
      if (event.key === "Enter") {
        getReviewed({
          variables: {
            organisationId: organisationId,
            teamId: teamId,
            limit: LIMIT,
            offset: 0,
            searchText: reviewedSearch,
            role: role
          }
        });
      }
    },
    placeholder: "Search ".concat(name),
    value: reviewedSearch ? reviewedSearch : "",
    className: "review-usage-search-root-search-input"
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "review-usage-search-root-search-button-div ".concat(window.innerWidth < 768 ? "review-usage-search-root-search-button-div-mobile" : ""),
    onClick: function onClick() {
      getReviewed({
        variables: {
          organisationId: organisationId,
          teamId: teamId,
          limit: LIMIT,
          offset: 0,
          searchText: reviewedSearch,
          role: role
        }
      });
    },
    disabled: reviewedLoading || reviewedSearch == null || reviewedSearch == ""
  }, "Search Apps")), /*#__PURE__*/React.createElement("div", {
    className: "review-usage-root-listing"
    // onScroll={(e) => {
    //   handleScroll(e);
    // }}
  }, reviewedLoading ? /*#__PURE__*/React.createElement(Loader, null) : list && list.length !== 0 ? list.map(function (item) {
    var title = item.title,
      productivityStatus = item.productivityStatus,
      icon = item.icon,
      appType = item.appType;
    return /*#__PURE__*/React.createElement("div", {
      className: "bg-light rounded-lg mb-2 p-2 review-usage-root-listing-whole-div",
      key: "".concat(title, "-reviewed-app-list"),
      onMouseEnter: function onMouseEnter() {
        setOnHoverReviewedStatus(title);
      },
      onMouseLeave: function onMouseLeave() {
        setOnHoverReviewedStatus(null);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "d-flex align-items-center flex-grow-1 review-usage-root-listing-whole-div-names"
    }, /*#__PURE__*/React.createElement("img", {
      className: "review-usage-root-listing-card-content-avatar",
      src: icon
    }), /*#__PURE__*/React.createElement("div", {
      className: "review-usage-root-listing-card-content-title"
    }, title, onHoverReviewedStatus == title && copyReviewedStatus == null ? /*#__PURE__*/React.createElement("a", {
      className: "review-usage-root-listing-card-content-copy-button",
      onClick: function onClick() {
        return copyToClipboardReviewed(title, setCopyReviewedStatus);
      }
    }, "Copy") : onHoverReviewedStatus == title && copyReviewedStatus == title ? /*#__PURE__*/React.createElement("span", {
      className: "review-usage-root-listing-card-content-copied-status"
    }, "Copied") : null)), /*#__PURE__*/React.createElement(ReviewButtons, {
      productivityStatus: productivityStatus,
      onChange: function onChange(newStatus) {
        return handleReview(newStatus, item, teamId, role);
      }
    }));
  }) : reviewedSearch ? /*#__PURE__*/React.createElement("div", {
    className: "search-not-found-text"
  }, "Your search \"".concat(reviewedSearch, "\" is not found in the Reviewed apps. You can try search in the Unreviewed apps")) : !reviewedLoading ? /*#__PURE__*/React.createElement("div", {
    className: "review-usage-root-list-no-text"
  }, "No data found.") : null, !reviewedLoading && list && (list === null || list === void 0 ? void 0 : list.length) != 0 ? /*#__PURE__*/React.createElement("div", {
    className: "review-apps-load-more-button"
  }, !isReviewedAllLoaded ? isReviewedLoadingMore ? /*#__PURE__*/React.createElement("div", {
    className: "review-apps-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    onClick: function onClick() {
      return handleScroll();
    },
    className: "review-usage-load-more-button"
  }, "Load More") : null, isReviewedAllLoaded && list && list.length !== 0 ? /*#__PURE__*/React.createElement("p", {
    className: "screenshot-load-more-button review-usage-light-color"
  }, "You have seen all the apps") : null) : null));
}
function TopUsedApp(props) {
  var list = props.list,
    organisationId = props.organisationId,
    teamId = props.teamId,
    name = props.name,
    fetchMore = props.fetchMore,
    getTopUsedApp = props.getTopUsedApp,
    topUsedAppLoading = props.topUsedAppLoading,
    isTopUsedAppLoadingMore = props.isTopUsedAppLoadingMore,
    setTopUsedAppIsLoadingMore = props.setTopUsedAppIsLoadingMore,
    isTopUsedAppAllLoaded = props.isTopUsedAppAllLoaded,
    setTopUsedAppIsAllLoaded = props.setTopUsedAppIsAllLoaded,
    topUsedAppSearch = props.topUsedAppSearch,
    setTopUsedAppSearch = props.setTopUsedAppSearch,
    organisationSettings = props.organisationSettings,
    role = props.role;
  var _React$useState45 = React.useState(null),
    _React$useState46 = _slicedToArray(_React$useState45, 2),
    onHoverReviewedStatus = _React$useState46[0],
    setOnHoverReviewedStatus = _React$useState46[1];
  var _React$useState47 = React.useState(null),
    _React$useState48 = _slicedToArray(_React$useState47, 2),
    copyReviewedStatus = _React$useState48[0],
    setCopyReviewedStatus = _React$useState48[1];
  function handleScroll(e) {
    if (topUsedAppLoading) return;
    setTopUsedAppIsLoadingMore(true);
    fetchMore({
      variables: {
        offset: list.length
      },
      updateQuery: function updateQuery(prev, _ref9) {
        var fetchMoreResult = _ref9.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if (fetchMoreResult.topUsedReviewReviewedApps.topUsedReviewReviewedApp.length < LIMIT && !isTopUsedAppAllLoaded) {
          setTopUsedAppIsAllLoaded(true);
          setTopUsedAppIsLoadingMore(false);
        }
        setTopUsedAppIsLoadingMore(false);
        return _objectSpread(_objectSpread({}, prev), {}, {
          topUsedReviewReviewedApps: _objectSpread(_objectSpread({}, prev.topUsedReviewReviewedApps), {}, {
            topUsedReviewReviewedApp: [].concat(_toConsumableArray(prev.topUsedReviewReviewedApps.topUsedReviewReviewedApp), _toConsumableArray(fetchMoreResult.topUsedReviewReviewedApps.topUsedReviewReviewedApp))
          })
        });
      }
    });

    //setLimits(LIMIT + 20);
    // }
  }
  var _useMutation5 = useMutation(REVIEW_APP_MUTATION),
    _useMutation6 = _slicedToArray(_useMutation5, 2),
    addAppProductivityStatus = _useMutation6[0],
    addAppProductivityStatusLoading = _useMutation6[1].loading;
  var handleReview = React.useCallback( /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(newStatus, app, teamId) {
      var appName, appType, appCategory;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            if (!addAppProductivityStatusLoading) {
              _context7.next = 2;
              break;
            }
            return _context7.abrupt("return", null);
          case 2:
            appName = app.title, appType = app.appType, appCategory = app.appCategory;
            _context7.prev = 3;
            _context7.next = 6;
            return addAppProductivityStatus({
              variables: {
                appName: appName,
                appType: appType,
                appCategory: appCategory,
                productivityStatus: newStatus,
                organisationId: organisationId,
                teamId: teamId == "all" ? null : teamId,
                canBeIdle: false,
                role: role
              }
            });
          case 6:
            toast.success("Review status updated successfully!");
            _context7.next = 12;
            break;
          case 9:
            _context7.prev = 9;
            _context7.t0 = _context7["catch"](3);
            console.log(_context7.t0);
          case 12:
          case "end":
            return _context7.stop();
        }
      }, _callee7, null, [[3, 9]]);
    }));
    return function (_x9, _x10, _x11) {
      return _ref10.apply(this, arguments);
    };
  }(), []);
  return /*#__PURE__*/React.createElement("div", {
    className: "p-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "top-review-usage-root-note-text"
  }, /*#__PURE__*/React.createElement(Alert, {
    key: "api-limit-waring",
    variant: "warning",
    className: "top-review-app-list-card-toolbar-alert-text"
  }, "Note: Top used apps/sites in the last 30 days are listed here. Maximum of 50 apps/sites will be shown here.")), /*#__PURE__*/React.createElement("div", {
    className: "review-usage-root-listing"
    // onScroll={(e) => {
    //   handleScroll(e);
    // }}
  }, topUsedAppLoading ? /*#__PURE__*/React.createElement(Loader, null) : list && list.length !== 0 ? list.map(function (item, key) {
    var title = item.title,
      productivityStatus = item.productivityStatus,
      icon = item.icon,
      appType = item.appType,
      totalSecInHour = item.totalSecInHour;
    return /*#__PURE__*/React.createElement(React.Fragment, null, key == 0 ? /*#__PURE__*/React.createElement("div", {
      className: "review-header-datas"
    }, /*#__PURE__*/React.createElement("div", {
      className: "d-flex align-items-center review-comman-div flex-grow-1"
    }, /*#__PURE__*/React.createElement("div", {
      className: "d-flex align-items-center review-header-datas-app"
    }, "App title"), /*#__PURE__*/React.createElement("div", {
      className: "d-flex align-items-center review-header-datas-hours"
    }, "Total worked hours")), /*#__PURE__*/React.createElement("div", {
      className: "review-comman-div-split"
    }, "Review status")) : null, /*#__PURE__*/React.createElement("div", {
      className: "bg-light rounded-lg mb-2 p-2 review-usage-root-listing-whole-div",
      key: "".concat(title, "-reviewed-app-list"),
      onMouseEnter: function onMouseEnter() {
        setOnHoverReviewedStatus(title);
      },
      onMouseLeave: function onMouseLeave() {
        setOnHoverReviewedStatus(null);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "d-flex align-items-center flex-grow-1 review-usage-root-listing-whole-div-names"
    }, /*#__PURE__*/React.createElement("img", {
      className: "review-usage-root-listing-card-content-avatar",
      src: icon
    }), /*#__PURE__*/React.createElement("div", {
      className: "review-usage-root-listing-card-content-title"
    }, title, onHoverReviewedStatus == title && copyReviewedStatus == null ? /*#__PURE__*/React.createElement("a", {
      className: "review-usage-root-listing-card-content-copy-button",
      onClick: function onClick() {
        return copyToClipboardReviewed(title, setCopyReviewedStatus);
      }
    }, "Copy") : onHoverReviewedStatus == title && copyReviewedStatus == title ? /*#__PURE__*/React.createElement("span", {
      className: "review-usage-root-listing-card-content-copied-status"
    }, "Copied") : null), /*#__PURE__*/React.createElement("div", {
      className: "review-usage-root-listing-card-content-title-hour"
    }, totalSecInHour)), /*#__PURE__*/React.createElement(ReviewButtons, {
      productivityStatus: productivityStatus,
      onChange: function onChange(newStatus) {
        return handleReview(newStatus, item, teamId);
      }
    })));
  }) : topUsedAppSearch ? /*#__PURE__*/React.createElement("div", {
    className: "search-not-found-text"
  }, "Your search \"".concat(topUsedAppSearch, "\" is not found in the Reviewed apps. You can try search in the Unreviewed apps")) : !topUsedAppLoading ? /*#__PURE__*/React.createElement("div", {
    className: "review-usage-root-list-no-text"
  }, "No data found.") : null, !topUsedAppLoading && list && (list === null || list === void 0 ? void 0 : list.length) != 0 && (list === null || list === void 0 ? void 0 : list.length) < 50 ? /*#__PURE__*/React.createElement("div", {
    className: "review-apps-load-more-button"
  }, !isTopUsedAppAllLoaded ? isTopUsedAppLoadingMore ? /*#__PURE__*/React.createElement("div", {
    className: "review-apps-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    onClick: function onClick() {
      return handleScroll();
    },
    className: "review-usage-load-more-button"
  }, "Load More") : null, isTopUsedAppAllLoaded && list && list.length !== 0 ? /*#__PURE__*/React.createElement("p", {
    className: "screenshot-load-more-button review-usage-light-color"
  }, "You have seen all the apps") : null) : null));
}
var ChangeExcludeIdleAppStatusModal = function ChangeExcludeIdleAppStatusModal(props) {
  var showIdleAppStatusModal = props.showIdleAppStatusModal,
    setShowIdleAppStatusModal = props.setShowIdleAppStatusModal,
    organisationId = props.organisationId,
    teamId = props.teamId,
    excludeIdleAppSearch = props.excludeIdleAppSearch,
    tz = props.tz,
    handleIdleAppClose = props.handleIdleAppClose,
    role = props.role,
    idleAppUpdateStatus = props.idleAppUpdateStatus,
    setIdleAppUpdateStatus = props.setIdleAppUpdateStatus;
  if (showIdleAppStatusModal === null) {
    return null;
  }
  var appName = showIdleAppStatusModal.appName,
    idleStatus = showIdleAppStatusModal.idleStatus;
  var _React$useState49 = React.useState(null),
    _React$useState50 = _slicedToArray(_React$useState49, 2),
    deleteStatus = _React$useState50[0],
    setDeleteStatus = _React$useState50[1];
  var _useMutation7 = useMutation(CHANGE_IDLE_APP_STATUS_MUTATION),
    _useMutation8 = _slicedToArray(_useMutation7, 2),
    changeIdleAppStatus = _useMutation8[0],
    changeIdleAppStatusLoading = _useMutation8[1].loading;
  var handleExcludeAppStatus = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
    var response;
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          if (!changeIdleAppStatusLoading) {
            _context8.next = 2;
            break;
          }
          return _context8.abrupt("return", null);
        case 2:
          _context8.prev = 2;
          _context8.next = 5;
          return changeIdleAppStatus({
            variables: {
              appName: appName,
              organisationId: organisationId,
              teamId: teamId == "all" ? null : teamId,
              idleStatus: idleStatus
            },
            awaitRefetchQueries: true,
            refetchQueries: [{
              query: EXCLUDE_APPS_FROM_IDLE_TIME_QUERY,
              variables: {
                organisationId: organisationId,
                teamId: teamId,
                searchText: null,
                role: role
              }
            }]
          });
        case 5:
          response = _context8.sent;
          if (!response || !response.data || response.data.changeIdleAppStatus === false) {
            toast.error("Error Occured, Try again later!");
            handleIdleAppClose();
          } else {
            toast.success("Idle app status updated successfully!");
            setIdleAppUpdateStatus(function (prevState) {
              return [].concat(_toConsumableArray(prevState.filter(function (item) {
                return item.appName !== appName;
              })), [
              // Remove existing entry
              {
                appName: appName,
                idleStatus: idleStatus
              } // Add new entry
              ]);
            });
            handleIdleAppClose();
          }
          _context8.next = 12;
          break;
        case 9:
          _context8.prev = 9;
          _context8.t0 = _context8["catch"](2);
          console.log(_context8.t0);
        case 12:
        case "end":
          return _context8.stop();
      }
    }, _callee8, null, [[2, 9]]);
  })), []);
  return /*#__PURE__*/React.createElement(Modal, {
    show: showIdleAppStatusModal,
    onHide: handleIdleAppClose
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "project-details-task-card-delete-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-details-task-card-delete-title"
  }, idleStatus ? "Exclude Idle Time Detection" : "Include in Idle Time Detection")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "project-details-task-card-delete-body"
  }, idleStatus ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "exclude-idle-time-app-modal-text-1"
  }, "Would you like to exclude ", appName, " from idle time detection?"), /*#__PURE__*/React.createElement("div", {
    className: "exclude-idle-time-app-modal-text-2"
  }, "When excluded, time spent on this app or website will always be counted as active, even if no activity is detected.")) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "exclude-idle-time-app-modal-text-1"
  }, "Would you like to include ", appName, " in idle time detection again?"), /*#__PURE__*/React.createElement("div", {
    className: "exclude-idle-time-app-modal-text-2"
  }, "This means activity on ", appName, " will be counted as idle time if there\u2019s no interaction for a while."))), /*#__PURE__*/React.createElement(Modal.Footer, {
    className: "exclude-idle-time-app-modal-footer"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "success",
    className: "project-details-task-card-delete-button",
    onClick: function onClick() {
      return handleExcludeAppStatus();
    },
    disabled: changeIdleAppStatusLoading
  }, deleteStatus === true ? "Updated" : changeIdleAppStatusLoading ? "Updating" : idleStatus ? "Yes, exclude" : "Yes, include"), /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-details-task-card-delete-cancel-button",
    onClick: handleIdleAppClose,
    disabled: changeIdleAppStatusLoading
  }, idleStatus ? "No, keep detecting idle time" : "No, keep excluded")));
};
function ExcludeAppsFromIdleTime(props) {
  var list = props.list,
    organisationId = props.organisationId,
    teamId = props.teamId,
    name = props.name,
    fetchMore = props.fetchMore,
    getExcludeIdleApps = props.getExcludeIdleApps,
    excludeIdleAppsLoading = props.excludeIdleAppsLoading,
    isExcludeIdleAppLoadingMore = props.isExcludeIdleAppLoadingMore,
    setExcludeIdleAppIsLoadingMore = props.setExcludeIdleAppIsLoadingMore,
    isExcludeIdleAppAllLoaded = props.isExcludeIdleAppAllLoaded,
    setExcludeIdleAppIsAllLoaded = props.setExcludeIdleAppIsAllLoaded,
    excludeIdleAppSearch = props.excludeIdleAppSearch,
    setExcludeIdleAppSearch = props.setExcludeIdleAppSearch,
    organisationSettings = props.organisationSettings,
    role = props.role;
  var _React$useState51 = React.useState(null),
    _React$useState52 = _slicedToArray(_React$useState51, 2),
    showIdleAppStatusModal = _React$useState52[0],
    setShowIdleAppStatusModal = _React$useState52[1];
  var _React$useState53 = React.useState(false),
    _React$useState54 = _slicedToArray(_React$useState53, 2),
    excludeSearchButtonClick = _React$useState54[0],
    setExcludeSearchButtonClick = _React$useState54[1];
  var _React$useState55 = React.useState([]),
    _React$useState56 = _slicedToArray(_React$useState55, 2),
    idleAppUpdateStatus = _React$useState56[0],
    setIdleAppUpdateStatus = _React$useState56[1];
  var handleIdleAppClose = function handleIdleAppClose() {
    setShowIdleAppStatusModal(null);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "p-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "review-usage-search-root-div ".concat(window.innerWidth < 768 ? "review-usage-search-root-div-mobile" : "")
  }, /*#__PURE__*/React.createElement(FormControl, {
    onChange: function onChange(e) {
      setExcludeIdleAppSearch(e.target.value);
      setExcludeSearchButtonClick(false);
      if (e.target.value == "") {
        getExcludeIdleApps({
          variables: {
            organisationId: organisationId,
            teamId: teamId,
            searchText: null,
            timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
            role: role
          }
        });
      }
    },
    onKeyPress: function onKeyPress(event) {
      if (event.key === "Enter") {
        setExcludeSearchButtonClick(true);
        getExcludeIdleApps({
          variables: {
            organisationId: organisationId,
            teamId: teamId,
            searchText: excludeIdleAppSearch,
            timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
            role: role
          }
        });
      }
    },
    placeholder: "Search the app/site for idle exclusion",
    value: excludeIdleAppSearch ? excludeIdleAppSearch : "",
    className: "review-usage-search-root-search-input"
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "review-usage-search-root-search-button-div ".concat(window.innerWidth < 768 ? "review-usage-search-root-search-button-div-mobile" : ""),
    onClick: function onClick() {
      setExcludeSearchButtonClick(true);
      getExcludeIdleApps({
        variables: {
          organisationId: organisationId,
          teamId: teamId,
          searchText: excludeIdleAppSearch,
          timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
          role: role
        }
      });
    },
    disabled: excludeIdleAppsLoading || excludeIdleAppSearch == null || excludeIdleAppSearch == ""
  }, "Search Apps")), /*#__PURE__*/React.createElement("div", {
    className: "review-usage-root-listing"
  }, excludeIdleAppsLoading ? /*#__PURE__*/React.createElement(Loader, null) : list && list.length !== 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, !excludeSearchButtonClick ? /*#__PURE__*/React.createElement("div", {
    className: "exclude-idle-time-app-content-idle-label"
  }, "The following apps and websites are excluded from idle detection.") : null, list.map(function (item, key) {
    var appName = item.appName,
      idleStatus = item.idleStatus;
    var appData = idleAppUpdateStatus.find(function (item) {
      return item.appName === appName;
    });
    if (appData) {
      idleStatus = appData.idleStatus == true ? "true" : "false";
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "rounded-lg mb-3 p-2 review-usage-root-listing-whole-div exclude-idle-time-app-listing-whole-div",
      key: "".concat(appName, "-reviewed-app-list")
    }, /*#__PURE__*/React.createElement("div", {
      className: "d-flex align-items-center flex-grow-1 review-usage-root-listing-whole-div-names"
    }, /*#__PURE__*/React.createElement("div", {
      className: "review-usage-root-listing-card-content-title"
    }, appName)), /*#__PURE__*/React.createElement("div", null, idleStatus == "true" ? /*#__PURE__*/React.createElement(Button, {
      variant: "outline-secondary",
      className: "exclude-idle-time-app-content-add-button",
      onClick: function onClick() {
        setShowIdleAppStatusModal({
          appName: appName,
          idleStatus: false
        });
      }
    }, "Remove") : /*#__PURE__*/React.createElement(Button, {
      variant: "outline-secondary",
      className: "exclude-idle-time-app-content-add-button",
      onClick: function onClick() {
        setShowIdleAppStatusModal({
          appName: appName,
          idleStatus: true
        });
      }
    }, "Add"))));
  })) : excludeIdleAppSearch && excludeSearchButtonClick ? /*#__PURE__*/React.createElement("div", {
    className: "exclude-idle-app-search-not-found-text"
  }, "\"".concat(excludeIdleAppSearch, "\"  isn\u2019t in the used apps/sites list. It will appear once a team member starts using it. If you search for the app or site, the results will consider usage data from the last 30 days.")) : !excludeIdleAppsLoading && !excludeSearchButtonClick && !excludeIdleAppSearch && list && list.length == 0 ? /*#__PURE__*/React.createElement("div", {
    className: "exclude-idle-app-root-list-no-text"
  }, "You have not excluded idle detection for any application or website. If you search for the app or site, it will still appear in the list.") : null), /*#__PURE__*/React.createElement(ChangeExcludeIdleAppStatusModal, {
    showIdleAppStatusModal: showIdleAppStatusModal,
    setShowIdleAppStatusModal: setShowIdleAppStatusModal,
    organisationId: organisationId,
    teamId: teamId,
    excludeIdleAppSearch: excludeIdleAppSearch,
    tz: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    handleIdleAppClose: handleIdleAppClose,
    role: role,
    idleAppUpdateStatus: idleAppUpdateStatus,
    setIdleAppUpdateStatus: setIdleAppUpdateStatus
  }));
}
var ReviewButtons = function ReviewButtons(props) {
  var productivityStatus = props.productivityStatus,
    onChange = props.onChange,
    loading = props.loading;
  var _React$useState57 = React.useState(productivityStatus),
    _React$useState58 = _slicedToArray(_React$useState57, 2),
    status = _React$useState58[0],
    setStatus = _React$useState58[1];
  var isDemoOrLiveSite = findDemoOrLiveSite();
  var handleShow = function handleShow(data) {
    setStatus(data);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "review-usage-root-listing-card-button"
  }, isDemoOrLiveSite === "demo" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(OverlayTrigger, {
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-demo-site"
    }, "You can't edit status in demo site.")
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-success",
    className: "rounded-pill px-3 disable-button",
    size: "sm",
    active: status === "productive"
  }, "Productive")), /*#__PURE__*/React.createElement(OverlayTrigger, {
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-demo-site"
    }, "You can't edit status in demo site.")
  }, /*#__PURE__*/React.createElement(Button, {
    active: status === "neutral",
    variant: "outline-secondary",
    className: "rounded-pill px-3 disable-button",
    size: "sm"
  }, "Neutral")), /*#__PURE__*/React.createElement(OverlayTrigger, {
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-demo-site"
    }, "You can't edit status in demo site.")
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-danger",
    active: status === "unproductive",
    className: "rounded-pill px-3 disable-button",
    size: "sm"
  }, "Unproductive"))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-success",
    className: "rounded-pill review-usage-root-listing-reviewed-button",
    size: "sm",
    active: status === "productive",
    onClick: function onClick() {
      onChange("productive");
      handleShow("productive");
    },
    disabled: loading
  }, "Productive"), /*#__PURE__*/React.createElement(Button, {
    active: status === "neutral",
    onClick: function onClick() {
      onChange("neutral");
      handleShow("neutral");
    },
    variant: "outline-secondary",
    disabled: loading,
    className: "rounded-pill review-usage-root-listing-reviewed-button",
    size: "sm"
  }, "Neutral"), /*#__PURE__*/React.createElement(Button, {
    variant: "outline-danger",
    active: status === "unproductive",
    onClick: function onClick() {
      onChange("unproductive");
      handleShow("unproductive");
    },
    disabled: loading,
    className: "rounded-pill review-usage-root-listing-reviewed-button",
    size: "sm"
  }, "Unproductive")));
};
export default ReviewUsage;